import { Slider, Typography } from '@material-ui/core';
import { useField } from 'formik';
import React from 'react';
import styled from 'styled-components';

type Props = {
  name: string;
  min: number;
  max: number;
  step: number;
};

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

const BoundaryValue = styled.span`
  width: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 0 3px;
`;

const Boundary = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const BoundaryEnd = styled(Boundary)`
  justify-content: flex-end;
`;

const SliderWrapper = styled.div`
  flex: 8;
  align-items: 'center';
  display: 'flex' auto;
`;

export default function SliderField({ name, min, max, step }: Props) {
  const [field, { value }] = useField(name);

  const onChange = (_: React.ChangeEvent<{}>, value: number | number[]) => {
    field.onChange({
      target: {
        name,
        value
      }
    });
  };

  return (
    <Container>
      <Boundary>
        <BoundaryValue>
          <Typography variant="h5">{value ? value[0] : '-'}</Typography>
        </BoundaryValue>
      </Boundary>
      <SliderWrapper>
        <Slider
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={onChange}
        ></Slider>
      </SliderWrapper>

      <BoundaryEnd>
        <BoundaryValue>
          <Typography variant="h5">{value ? value[1] : '-'}</Typography>
        </BoundaryValue>
      </BoundaryEnd>
    </Container>
  );
}
